var $name="toBoolean",$path="app/utilities/toBoolean.js",$this={$name,$path,};export default (value) => value === true || value === '1' || value === 'true';
